import { useEffect } from 'react';
import '@/pages/home/home.css';
import SiteNav from '@/components/feature/SiteNav';
import VisitFooter from '@/pages/home/components/VisitFooter';
import StoryHero from './components/StoryHero';
import Philosophy from './components/Philosophy';
import Process from './components/Process';
import Shared from './components/Shared';

export default function StoryPage() {
  useEffect(() => {
    document.title = 'Our Story — FOLD. Artisan Bakery';
    document.querySelector('meta[name="description"]')?.setAttribute('content', 'The FOLD. story: hand-laminated pastry made with patience. The fold, the rest and the bake behind every croissant from our small artisan bakery.');
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="fold-home">
      <SiteNav />
      <main>
        <StoryHero />
        <Philosophy />
        <Process />
        <Shared />
        <VisitFooter showVisit={false} />
      </main>
    </div>
  );
}